<template>
  <div
    :class="[
      'w-min relative',
      'flex justify-center items-center',
      'bg-base-100 rounded-lg border border-base-content/20 focus-within:border-base-content/50',
    ]"
  >
    <input
      class="color-text input border-transparent font-mono text-center w-[12ch]"
      type="text"
      v-model="inputColor"
    />

    <PopupButton placement="right" :offset="-2" :renderOnShow="true">
      <template #button>
        <ColorDot :color="hexColor" />
      </template>
      <template #popup>
        <div class="p-2">
          <ColorPicker
            :modelValue="modelValue"
            @update:modelValue="(v) => $emit('update:modelValue', v)"
          />
        </div>
      </template>
    </PopupButton>
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { colord } from "colord";
import { RGB8 } from "@/keyboard";
import ColorDot from "@/components/utils/ColorDot.vue";
import ColorPicker from "@/components/utils/ColorPicker.vue";
import PopupButton from "@/components/utils/PopupButton.vue";

const props = defineProps<{
  modelValue: RGB8;
}>();

const emit = defineEmits<{
  (_e: "update:modelValue", _value: RGB8): void;
}>();

const fromRgb8 = (c: RGB8) => ({ r: c[0], g: c[1], b: c[2] });
const toRgb8 = (c: {
  r: number;
  g: number;
  b: number;
}): [number, number, number] => [c.r, c.g, c.b];

const hexColor = computed(() => colord(fromRgb8(props.modelValue)).toHex());
const inputColor = ref(hexColor.value);

watch(hexColor, () => (inputColor.value = hexColor.value));

watch(inputColor, (text) => {
  const color = colord(text);
  if (!color.isValid()) return;
  emit("update:modelValue", toRgb8(color.toRgb()));
});
</script>
